import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMicrophoneLines, faPenToSquare, faPrint, faSquarePlus } from '@fortawesome/free-solid-svg-icons'


const SongsNavbar = () => {
  return (
    <nav>
      <ul className="footerNav">
        <li>
          <NavLink  className={({ isActive }) => (isActive ? 'active-sub' : 'inactive')} to="/songs"> <FontAwesomeIcon icon={faMicrophoneLines}/> Songs</NavLink>
        </li>
        <li>
          <NavLink  className={({ isActive }) => (isActive ? 'active-sub' : 'inactive')} to="/songs/create"><FontAwesomeIcon icon={faSquarePlus}/> Create Song</NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default SongsNavbar